import { useContext } from 'react';

import {
  CurrentUserContext,
  CurrentUserContextValue,
} from '../providers/CurrentUserProvider';

export const useCurrentUserRoles = () => {
  return {
    isAdmin: useContext<CurrentUserContextValue>(CurrentUserContext).isAdmin,
    isAgent: useContext<CurrentUserContextValue>(CurrentUserContext).isAgent,
    isCorporateUser:
      useContext<CurrentUserContextValue>(CurrentUserContext).isCorporateUser,
    isCustomer:
      useContext<CurrentUserContextValue>(CurrentUserContext).isCustomer,
  };
};
